import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { gql, useQuery } from '@apollo/client';

import assets from 'services/assets';

// assets
import CssBackdrop from './Backdrop.scss';

const GET_BACKDROP = gql`
  query GetBackdrop {
    Backdrop {
      id
      filename
    }
  }
`;

function Backdrop(props) {
  const { children, maxWidth, partner } = props;
  useStyles(CssBackdrop);

  const { error, data } = useQuery(GET_BACKDROP, {
    fetchPolicy: 'cache-first',
    skip: !!props.filename,
  });

  let filename;
  if (error) {
    filename = 'default.jpg';
  } else {
    filename = data?.Backdrop?.filename || props.filename;
  }
  const style = {};
  if (typeof partner === 'string' && typeof props.filename === 'string') {
    style.backgroundImage = `-webkit-image-set(
      url(${assets.partnerUrl(props.filename, {
        partner,
        resize: 'fit-in',
        width: 1024,
        height: 768,
      })}) 1x,
      url(${assets.partnerUrl(props.filename, {
        partner,
        resize: 'fit-in',
        width: 2048,
        height: 1536,
      })}) 2x,
      url(${assets.partnerUrl(props.filename, {
        partner,
        resize: 'fit-in',
        width: 4096,
        height: 3072,
      })}) 4x
    )`;
  } else if (filename) {
    style.backgroundImage = `-webkit-image-set(
      url(${assets.backdropUrl(filename, {
        resize: 'fit-in',
        width: 1024,
        height: 768,
      })}) 1x,
      url(${assets.backdropUrl(filename, {
        resize: 'fit-in',
        width: 2048,
        height: 1536,
      })}) 2x
    )`;
  }
  return (
    <div className="backdrop" style={style}>
      <Container className="backdrop__container" maxWidth={maxWidth} align="center">
        <Paper className="backdrop__paper">{children}</Paper>
      </Container>
    </div>
  );
}

Backdrop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  maxWidth: PropTypes.string,
  partner: PropTypes.string,
  filename: PropTypes.string,
};

Backdrop.defaultProps = {
  maxWidth: 'sm',
  partner: null,
  filename: null,
};

export default Backdrop;
